<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/12qqRwg/tc-custom/9781571318008.jpg?1713582816453" alt="This image is the cover for the book Driftless"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Driftless
      </h1>
      <p class="bookDescription body article font2">
        <b>“A fast-moving story about small town life with characters that seem to have walked off the pages of Edgar Lee Masters’s Spoon River Anthology.”—<i>The Wall Street Journal</i></b><br/>  <br/> The few hundred souls who inhabit Words, Wisconsin, are an extraordinary cast of characters. The middle-aged couple who zealously guards their farm from a scheming milk cooperative. The lifelong invalid, crippled by conflicting emotions about her sister. A cantankerous retiree, haunted by childhood memories after discovering a cougar in his haymow. The former drifter who forever alters the ties that bind a community. In his first novel in 30 years, David Rhodes offers a vivid and unforgettable look at life in small-town America.<br/>  <br/> “[Rhodes’s] finest work yet . . . <i>Driftless</i> is the best work of fiction to come out of the Midwest in many years.”—<i>Chicago Tribune</i><br/>  <br/> “Set in a rural Wisconsin town, the book presents a series of portraits that resemble Edgar Lee Masters’s ‘Spoon River Anthology’ in their vividness and in the cumulative picture they create of village life.”—<i>The New Yorker</i><br/><br/> “Encompassing and incisive, comedic and profound, <i>Driftless</i> is a radiant novel of community and courage.”—<i>Booklist</i> (starred review)<br/>  <br/> “A welcome antidote to overheated urban fiction . . . A quiet novel of depth and simplicity.”—<i>Kirkus Reviews</i><br/>  <br/> “It takes a while for all these stories to kick in, but once they do, Rhodes shows he still knows how to keep readers riveted. Add a blizzard, a marauding cougar and some rabble-rousing militiamen, and the result is a novel that is as affecting as it is pleasantly overstuffed.”—<i>Publishers Weekly</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        David Rhodes
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Perseus
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?9d0961c6